<template>
  <div>
    <!-- 面包屑导航 -->
<!--    <el-breadcrumb separator-class="el-icon-arrow-right">-->
<!--      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>-->
<!--      <el-breadcrumb-item>其他渠道管理列表</el-breadcrumb-item>-->
<!--    </el-breadcrumb>-->
    <!-- 卡片 -->
    <el-card class="box-card">
      <!-- 搜索  新增-->
      <el-form
          :inline="true"
          :model="searchForm"
          ref="searchForRef"
          autocomplete="on">
        <el-row :gutter="24">
          <el-col :span="5">
            <el-form-item label="联系人姓名" size="small" label-width="90px">
              <el-input v-model="searchForm.contact_name" placeholder="请输入联系人姓名" clearable type="text"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="1">
            <el-button size="small" type="success" @click="searchSubmit()">搜索</el-button>
            <!-- <el-button @click="searchRest()">重置</el-button> -->
          </el-col>
          <el-col :span="1">
            <el-button size="small" type="primary" @click="addData">新增</el-button>
          </el-col>
        </el-row>

      </el-form>

        <!-- 表格 -->
        <el-table
            ref="multipleTable"
            :data="tableLoadData"
            stripe
            border
            height="450"
            size="mini"
            :header-cell-style="{background:'#e5e5e5',color:'#333333'}"
        >
            <el-table-column
              label="渠道联系人"
              min-width="15%"
              prop="contact_name"
              :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column
              label="渠道联系电话"
              prop="contact_mobile"
              min-width="15%"
              :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column
              label="添加时间"
              min-width="15%"
              prop="add_time"
              :show-overflow-tooltip='true'>
              <template slot-scope="scope">
                <span>{{ scope.row.add_time | dateFormat }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="经办人"
              min-width="15%"
              prop="op_name"
              :show-overflow-tooltip='true'>
            </el-table-column>

            <el-table-column
              label="操作"

              min-width="15%">
              <template slot-scope="scope">
                <el-button type="warning" size="small" icon="el-icon-edit" @click="handelEdit(scope.row)"></el-button>
                <el-button type="danger" size="small" icon="el-icon-delete" @click="handelDel(scope.row)"></el-button>
              </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="block" style="margin-top:10px">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-sizes="[10, 20, 30, 100]"
                :page-size="limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
          </el-pagination>
        </div>
    </el-card>
    <!-- 新增编辑弹框 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="70%">
      <el-form :model="form" :rules="rules" ref="form" label-width="110px">
          <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="渠道联系人" prop="contact_name" size="small">
                  <el-input v-model="form.contact_name" autocomplete="off" ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="渠道联系电话" prop="contact_mobile" size="small">
                  <el-input v-model="form.contact_mobile" autocomplete="off" ></el-input>
                </el-form-item>
              </el-col>
          </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reset_dialogForm('form')">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import eTable from "../common/eTable.vue";
import moment from 'moment'     //日期时间转换

export default {
  name: "shopInfoList",
  components: {
    eTable
  },
  props: {},
  data() {
    return {
      // 搜索
      searchForm: {
        contact_name: '',
      },
      searchRules: {
        contact_name: [
          { required: true, message: "请输入联系人姓名", trigger: "blur" },
        ],
      },
      // 数据
      tableLoadData: [],
      limit: 10,
      page:1,// 当前页码
      total:0,//总条目数
      id: '',
      rules: {
        name: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
        corporation: [{ required: true, message: '请输入法人', trigger: 'blur' }],
        credit_code: [{ required: true, message: '请输入社会信用代码', trigger: 'blur' }],
      },
      dialogFormVisible: false,
      title: '',
      form: {
        contact_name: '',
        contact_mobile: '',
      },    
      uploadImg: '',
      uploadDialog: false
    };
  },
  created() {
    this.DataList()
  },
  mounted() {},
    filters: {
    statusFilter(status) {
      if (status == 1) {
        return "启用";
      } else if (status == 2) {
        return "禁用";
      }
    },
       //时间格式化
    dateFormat(add_time) {
      if (add_time == undefined) {
        return "";
      }
      return moment(add_time*1000).format("yyyy-MM-DD HH:mm:ss");
    },

  },
  methods: {
    getTime (time) {
      var date = new Date(time)
      var y = date.getFullYear()
      var m = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
      var d = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
      return y + '-' + m + '-' + d
    },
    DataList(){
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
        page: this.page,
        pageSize:this.limit
      }
      if(this.searchForm.contact_name) param.contact_name = this.searchForm.contact_name
      this.$axios.getOtherChannelList(param).then(res=>{
        if(res.code == 200){
          this.tableLoadData = res.data.data
          this.total = res.data.total
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error=>{
        //console.log(error);
      })
    },
    // 设置每页条数
    handleSizeChange(newSize) {
      this.limit = newSize
      this.DataList()
    },
    // 分页跳转
    handleCurrentChange(newPage) {
      this.page = newPage
      this.DataList()
    },
    // 新增
    addData() {
      this.title = '新增'
      this.form = {
        // role_name: '',
      }
      this.dialogFormVisible = true
    },
    handelEdit(index,row) {
      this.id = index.id

      this.title = '编辑'
      this.form = {
      }
      this.dialogFormVisible = true
      // this.form = {...row};
      // 或者
      this.form = JSON.parse(JSON.stringify(index))
    },
    payInfo(index,row){
        this.$router.push({path:'/PayInfoList',query:{id:index.id}});
    },
   
    reset_dialogForm(formName) {
      this.dialogFormVisible = false
      this.$nextTick(() => {
        this.$refs[formName].resetFields()
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
              const param = {
                contact_name:this.form.contact_name,
                contact_mobile:this.form.contact_mobile,
                company_id:sessionStorage.getItem('company_id'),
                access_token:sessionStorage.getItem('token')
              }
              if(this.id) param.id = this.id
              this.$axios.saveOtherChannel(param).then(res =>{
              if(res.code == 200){
                this.DataList()
                this.$message.success(res.msg)
                this.dialogFormVisible = false
              }else{
                  this.$message.error(res.msg);
              }
            })
        }
      })
    },
    searchSubmit() {
      this.page = 1
      this.DataList()
    },

    handelDel(e) {
        this.$confirm('此操作将删除该渠道信息, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          id: e.id,    
        }
        //console.log(param);
        this.$axios.delOtherChannel(param).then(res=>{
          if(res.code == 200){
            this.$message.success(res.msg);
            this.DataList()
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error=>{
          //console.log(error);
        })
      }).catch(() => {
          // 点击取消:不删除了
          this.$message({
              type: 'info',
              message: '已取消删除'
          });
          this.DataList()
      });    
      this.teamDialog = false
    },
    // 点击弹出当前的图片
    handelDialog(index) {
      this.uploadDialog = true
      this.uploadImg = index.row.file_url.local_file_path
    }

  },
};
</script>
<style>
  .table_name{
      font-weight: bold;
      /* border: 1px solid #f00; */
  }
  .table_name:hover{
      color: #409EFF;
      cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/view/shipCompany/otherChannelList.vue